import React from 'react';
import ReactDiffViewer from 'react-diff-viewer-continued';
import { JobDTO } from 'types/types';
import './JobsDiff.scss';

interface JobsCompareProps {
  jobs: JobDTO[];
  oldCode: string;
  newCode: string;
}

const JobsDiff: React.FC<JobsCompareProps> = ({ jobs, oldCode, newCode }) => {
  return (
    <div className="jobs-diff-container">
      <ReactDiffViewer
        oldValue={oldCode}
        newValue={newCode}
        splitView={true}
        useDarkTheme={false}
        leftTitle={`Job ID: ${jobs[0].sparkJobId}`}
        rightTitle={`Job ID: ${jobs[1].sparkJobId}`}
        showDiffOnly={false}
        disableWordDiff={true}
      />
    </div>
  );
};

export default JobsDiff;
